const VOUCHER = {
  NOT_ENOUGH_BALANCE: 'You dont have enough balance for this voucher.',
} as const;

export default VOUCHER;
